import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-reason-dialog',
  templateUrl: './reason-dialog.component.html',
  styleUrls: ['./reason-dialog.component.scss']
})
export class ReasonDialogComponent implements OnInit {

  reasonform: FormGroup;
  LoaderComponent: any = '';
  keyword:boolean = false;
  keywordPrintAddress: any;
  keywordPrintData: any[] = [];
  loginData: any;
  advancedPrintAddress: any;
  advanced: boolean = false;
  advancedPrintData: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<ReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public service: WebRequestService,
    public fb: FormBuilder,
    private loginDataStore: Data
  ) {
    this.reasonform = this.fb.group({
      reasonForPrint: new FormControl('', [Validators.required, Validators.minLength(20)]),
    })
   }

  ngOnInit(): void {

    this.loginDataStore.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
    })
    .catch((err) => console.error(err));

    this.service.getData().subscribe((printData :any) =>{
      this.keywordPrintAddress = printData[0].address
      this.keyword = printData[0].address.keywordView;
      this.keywordPrintData = printData      
      // console.log(printData)
      if(printData[0].Type === 1) {
         this.keywordPrintAddress = printData[0].address
         this.keyword = printData[0].address.keywordView;
         this.keywordPrintData = printData
         this.converLakhsToCrores(this.keywordPrintData,1);
      }
      else {
      this.advancedPrintAddress = printData[0].address
      this.advanced = printData[0].address.advancedView;
      this.advancedPrintData = printData;
      this.converLakhsToCrores(this.advancedPrintData,2);
      }
    })

  }

  onNoClick(){
    this.dialogRef.close();
    if(this.keyword) {
      this.keywordPrintAddress.zipcode = '';
    }
  }

  onSubmitResponse() {
    const obj = {
      fromCustID: this.data.fromCustID,
      toCustID: this.data.toCustID,
      formatType: this.data.formateType,
      viewType: 2,
      isGetResponse: false,
      printReason: this.reasonform.value.reasonForPrint ? this.reasonform.value.reasonForPrint : null
    };
    this.LoaderComponent = LoaderComponent;
    this.service.updateEmpViewFormatAsync(obj).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.dialogRef.close(true);
      }
    })
  }

  redirectToViewProfile(profile_ID : string){
    let redirectToViewProfile = this.loginData.formatAccess;
    window.open(`/viewProfile;profileID=${profile_ID};format=${redirectToViewProfile}`, '_blank');
  }


    printMarketingData() {

    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
  <html>
    <head>
    <link rel="stylesheet" href=""  crossorigin="anonymous">
      <style>
      .col-md-1 {width:8%;  float:left;}
      .col-md-2 {width:16%; float:left;}
      .col-md-3 {width:25%; float:left;}
      .col-md-4 {width:33%; float:left;}
      .col-md-5 {width:42%; float:left;}
      .col-md-6 {width:50%; float:left;}
      .col-md-7 {width:58%; float:left;}
      .col-md-8 {width:66%; float:left;}
      .col-md-9 {width:75%; float:left;}
      .col-md-10{width:83%; float:left;}
      .col-md-11{width:92%; float:left;}
      .col-md-12{width:100%; float:left;}
      .ka-em-print-value{
        padding: 2% !important
      }
      .ka-em-print-screen-data{
        padding-top: 1% !important
      }
      @media print {
        .header {
          background-color: grey !important;
          color: white !important;
          font-size: 24px;
          font-weight: bold;
          text-align: center !important;
        }
      }
      </style>
    </head>
<body style="background-image: url(../../../assets/img/bg_img.png);" onload="window.print();window.close()">
<div class="header">
    <img src="../../../assets/img/dashboard/ka_logo.png" alt="Logo">
    <div>Kaakateeya.com</div>
</div>
${printContents}
</body>
  </html>`
    );
    popupWin.document.close();
  }

  converLakhsToCrores(records,type){
    for(let record of records){
      const convertedValueString = this.lakhsToCroresModifying(record.printData,type);
      record.printData = convertedValueString;
    }
  }
  
  lakhsToCroresModifying(inputString: string, type) { 
    if(type === 1){
      let modifiedString: any = inputString.replace(/Property: (\d+) lakhs/g, (match, lakhsValue) => {
        if(lakhsValue < 100)
          return `Property: ${lakhsValue} Lakhs`;
        else{
          const croreValue = Number(lakhsValue) / 100;      
          if(croreValue < 2)
             return `Property: ${croreValue} Crore`;
          else  
            return `Property: ${croreValue} Crores`;
        }      
      });
      return modifiedString;   
    }
    else{
      let modifiedString: any = inputString.replace(/Property : (\d+) lakhs/g, (match, lakhsValue) => {
        if(lakhsValue < 100)
          return `Property : ${lakhsValue} Lakhs`;
        else{
          const croreValue = Number(lakhsValue) / 100;      
          if(croreValue < 2)
             return `Property : ${croreValue} Crore`;
          else  
            return `Property : ${croreValue} Crores`;
        }      
      });
      return modifiedString; 
    }
     
  }
}
